<app-dialog
  [title]="
    selection.length > 1
      ? `¿Está seguro de rechazar los ${selection.length} calentadores seleccionados?`
      : `¿Está seguro de rechazar el calentador?`
  "
  [closeOnOverlay]="false"
>
  <form [formGroup]="form" class="form-deny" (ngSubmit)="handleConfirm()">
    @if (selection.length === 1) {
      <span><b>Serial:</b>{{ selection[0].serial }}</span>
    }
    <div class="control">
      <span class="input-length"
        >{{ observationsControl.value.length }} / 500</span
      >
      <input
        class="input"
        type="text"
        placeholder="Ingrese el motivo de rechazo"
        formControlName="observations"
      />
      <p
        class="error-message"
        [class.active]="
          observationsControl.touched && observationsControl.invalid
        "
      >
        @if (
          observationsControl.touched &&
          observationsControl.hasError("required")
        ) {
          Este campo es requerido
        }
        @if (
          observationsControl.touched &&
          (observationsControl.hasError("minlength") ||
            observationsControl.hasError("maxlength"))
        ) {
          El motivo debe tener entre 10 y 500 caracteres
        }
      </p>
    </div>
    <div class="actions">
      <app-button
        class="button"
        variant="primary"
        label="Confirmar"
        type="submit"
        [disabled]="form.invalid"
      ></app-button>
      <app-button
        class="button"
        variant="secondary"
        label="Cancelar"
        (onClick)="handleCancel()"
        type="button"
      ></app-button>
    </div>
  </form>
</app-dialog>
